import { render, staticRenderFns } from "./Tongpei.vue?vue&type=template&id=181f9e1c&scoped=true"
import script from "./Tongpei.vue?vue&type=script&lang=js"
export * from "./Tongpei.vue?vue&type=script&lang=js"
import style0 from "./Tongpei.vue?vue&type=style&index=0&id=181f9e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f9e1c",
  null
  
)

export default component.exports